module.exports = __webpack_public_path__ + "static/media/dog-and-cat.96578176.jpg";